module.exports = __webpack_public_path__ + "img/scenario_icon.ecc29808.svg";